import { FormTextInputComponent } from 'src/features/generalForms/builder/types/TextInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormTextInput: FormTextInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return <AnswerPreviewRow<string> value={value} isOptional={props.isOptional} renderValue={(val) => val} {...props} />;
};
